// inv/src/components/ui/badge.jsx

import { cn } from "../../lib/utils";

const VARIANT_STYLES = {
  v1: {
    wrap: "bg-emerald-50 text-stone-700 shadow-sm",
  },
  v2: {
    wrap: "bg-emerald-50 text-stone-700",
    hover: "hover:bg-emerald-100 hover:text-stone-700",
    close: "text-white/90 hover:text-white",
  },
  v3: { wrap: "text-stone-950", hover: "hover:bg-slate-200", close: "" },
  v4: { wrap: "text-stone-950", hover: "hover:bg-fuchsia-100", close: "" },
  v4_1: { wrap: "inline-flex h-7 items-center rounded-full bg-amber-50 text-amber-800 border border-amber-200 px-2 text-[11px] font-semibold shadow whitespace-nowrap" },
  v5: { wrap: "bg-zinc-800 text-white", hover: "", close: "" },
  v6: { wrap: "bg-purple-900 text-white", hover: "", close: "" },
  v7: { wrap: "bg-emerald-900 text-white", hover: "", close: "" },
};

const hasColorUtils = (s = "") =>
  /\b(bg-|text-|hover:bg-|hover:text-|fill-|stroke-)/.test(s);

const Badge = ({
  text,
  icon = null,
  className = "",
  removable = false,
  onRemove,
  as = "span",
  href = "#",
  variant = "v1", // v1 | v2 | v3 | v4 | v5
  ...props
}) => {
  const Component = as === "a" ? "a" : as;
  const styles = VARIANT_STYLES[variant] || VARIANT_STYLES.v1;

  const userSetsColor = hasColorUtils(className);

  return (
    <Component
      className={cn(
        "inline-flex w-fit self-start items-center justify-center",
        "px-3 py-1 rounded-md text-xs font-medium",
        "transition-colors duration-200",
        "max-w-full min-w-0 whitespace-normal break-words",
        !userSetsColor && styles.wrap,
        !userSetsColor && styles.hover,
        className
      )}
      href={as === "a" ? href : undefined}
      {...props}
    >
      {icon && <span className="flex-shrink-0 mr-1">{icon}</span>}
      <span className="whitespace-normal break-words text-center">{text}</span>
      {removable && (
        <button
          type="button"
          onClick={onRemove}
          className={cn(
            "ml-1 focus:outline-none",
            !userSetsColor && styles.close
          )}
          aria-label="Remove badge"
        >
          &times;
        </button>
      )}
    </Component>
  );
};

Badge.displayName = "Badge";

export { Badge, VARIANT_STYLES };
